module.exports = __webpack_public_path__ + "media/packs/images/flags/SD-e8405823e45c21a5b5b2330503496de9.png";